import { Absence } from "../../models/calendar/Absence.model";
import dayjs from "../../utils/dayjs";
import "./AbsenceBlock.css";

type Props = {
  absence: Absence;
  isDay: boolean;
  onClick?: (absence: Absence) => void;
};

export const AbsenceBlock = ({ absence, isDay, onClick }: Props) => {
  const name = absence.contact?.name || "Ausente";
  const start = dayjs(absence.start_at).tz();
  const end = dayjs(absence.end_at).tz();
  const when = absence.all_day
    ? "Todo el día"
    : `${start.format("h:mm A")}–${end.format("h:mm A")}`.replace(/\s/g, "");

  return (
    <div
      className={absence.all_day ? "absence-banner" : "absence-block"}
      title={`${name} · ${when}`}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(absence);
      }}
    >
      <span className="absence-label">{isDay ? `${name} · ${when}` : name}</span>
    </div>
  );
};
